<template>
  <ul class="project-filters">
    <li
      v-for="(filter, i) in filters"
      :key="i"
      :class="{ 'project-filters__item--is-active': filter.isActive }"
      class="project-filters__item"
      @click="$emit('click', filter)"
    >
      <button class="project-filters__btn" @click.prevent>
        {{ filter.title }}
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
  .project-filters {
    @include reset-list;

    @include media-down(lg) {
      &__item {
        display: inline-block;

        &:not(:last-child)::after {
          @include text(big, medium)
          content: '/';
          margin: 0 8px;
        }
      }
    }

    &__btn {
      @include reset-button;
      @include text(big, medium)
      text-transform: lowercase;
      position: relative;

      transition: color $base-transition;

      &:hover {
        @include theme-opposite(color);
      }
    }

    &__btn::after {
      content: '';
      position: absolute;
      bottom: 2px;
      left: 0;
      width: 100%;
      border-bottom: $accent-border-width solid;
      color: inherit;
      transform: scaleX(0);
      transform-origin: left;
      transition: transform $base-transition;
    }

    &__item--is-active &__btn::after {
      transform: scaleX(1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Projects/ProjectFilters.vue